/*
 * @Description:
 * @Author: lz
 * @Date: 2021-09-09 15:28:01
 * @LastEditTime: 2021-09-16 11:31:04
 * @LastEditors: lz
 */
import axios from 'axios'
import { message } from 'ant-design-vue'
import { getToken, getRoutePath } from '@/utils/auth'
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

const env = process.env.VUE_APP_ENV

const service = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  // 超时
  timeout: 50000,
  withCredentials: true
})
//请求拦截器
service.interceptors.request.use(
  (config) => {
    //添加token验证
    if (getToken()) {
      config.headers['Authorization'] = 'Bearer ' + getToken()
    }
    // 根据发布环境 设置 APPID
    if (env === 'dev' || env === 'test') {
      config.headers['HB-APP-ID'] = 'copr'
    } else {
      config.headers['HB-APP-ID'] = '012ac089c3bdd75ac6d1f6c56ab428b3'
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
//响应拦截器
service.interceptors.response.use((response) => {
  if (process.env.NODE_ENV != 'development' && response.data.code == 100000) {
    message.warning({
      content: '即将跳转到伙伴端登录',
      duration: 2
    })
    setTimeout(() => {
      window.open(getRoutePath() + window.location.href, '_self')
    }, 2000)
  } else if (response.data.code < 0) {
    message.error({
      content: response.data.message,
      duration: 2
    })
    return Promise.reject(response.data || 'Error')
  } else if (response.data.code == 1) {
    message.warn({
      content: response.data.message,
      duration: 2
    })
    return Promise.reject(response.data || 'Error')
  }
  return response.data
})

export default service
